import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PepDetailsFormErrorStatesEnum {
    CreatePepDetailsFailed = ErrorStateScheduleEnum.PepDetailsFormStatesStartIndex,
    UpdatePepDetailsFailed,
    DeletePepDetailsFailed,
    UpdateFinancialSanctionsFailed
}
